import React from 'react';
import { Check } from 'lucide-react';
import type { ProjetoEtapa } from '../../types';
import { ETAPAS_FLUXO, ETAPAS_DESVIO, configDaEtapa, indiceDaEtapa } from '../../src/lib/projetos/etapas';

interface EtapaStepperProps {
  etapa: ProjetoEtapa;
  /** Só adm/gerente edita; para os demais o stepper é leitura. */
  editavel: boolean;
  onChange: (etapa: ProjetoEtapa) => void;
}

/**
 * Régua da fase declarada. Pausado/cancelado não entram na régua (não são avanço): quando o
 * projeto está num deles, some a régua e aparece só o badge do desvio.
 */
const EtapaStepper: React.FC<EtapaStepperProps> = ({ etapa, editavel, onChange }) => {
  const atual = indiceDaEtapa(etapa);
  const cfg = configDaEtapa(etapa);

  if (atual === -1) {
    return (
      <div className="flex items-center gap-2">
        <span className={`text-xs font-bold uppercase px-2.5 py-1 rounded-full ${cfg.badge}`}>{cfg.rotulo}</span>
        {editavel && (
          <button type="button" onClick={() => onChange('em_execucao')} className="text-xs text-primary hover:underline">
            Retomar
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="flex flex-wrap items-center gap-1">
      {ETAPAS_FLUXO.map((e, i) => {
        const passada = i < atual;
        const ativa = i === atual;
        return (
          <React.Fragment key={e.valor}>
            <button
              type="button"
              disabled={!editavel}
              onClick={() => onChange(e.valor)}
              className={`flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold transition-colors ${
                ativa ? e.badge : passada ? 'text-gray-600 dark:text-gray-300' : 'text-gray-400 dark:text-gray-500'
              } ${editavel ? 'hover:bg-gray-100 dark:hover:bg-gray-700' : 'cursor-default'}`}
            >
              <span
                className="w-4 h-4 rounded-full flex items-center justify-center text-[9px] text-white"
                style={{ background: passada || ativa ? e.cor : '#d1d5db' }}
              >
                {passada ? <Check size={10} /> : i + 1}
              </span>
              {e.rotulo}
            </button>
            {i < ETAPAS_FLUXO.length - 1 && <span className="w-4 h-px bg-gray-300 dark:bg-gray-600" />}
          </React.Fragment>
        );
      })}
      {editavel && (
        <div className="flex items-center gap-1 ml-2 pl-2 border-l border-gray-200 dark:border-gray-700">
          {ETAPAS_DESVIO.map(e => (
            <button key={e.valor} type="button" onClick={() => onChange(e.valor)}
              className="text-[11px] text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
              {e.rotulo}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default EtapaStepper;
